import { render, staticRenderFns } from "./ceo.vue?vue&type=template&id=0550918e&scoped=true&"
import script from "./ceo.vue?vue&type=script&lang=js&"
export * from "./ceo.vue?vue&type=script&lang=js&"
import style0 from "./ceo.vue?vue&type=style&index=0&id=0550918e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0550918e",
  null
  
)

export default component.exports